<template>
    <span
        v-if="statusText && statusText.toLowerCase().includes('ignition off')"
        class="btn btn-sm btn-danger flat"
        style="width:170px"
    >
        IGNITION OFF
    </span>

    <span
        v-else-if="statusText && ['driving', 'start up'].some(text => statusText.toLowerCase().includes(text))"
        class="btn btn-sm btn-success flat"
        style="width:170px"
    >
        Driving
    </span>

    <span
        v-else
        class="btn btn-sm btn-warning flat"
        style="width:170px"
    >
        {{ statusText }}
    </span>
</template>

<script>
export default {
    name: 'StatusButton',
    props: {
        statusText: {
            type: String,
            default: ''
        }
    }
}
</script>